<template>
  <form @submit.prevent="retrievePassword({email})">
    <BaseAlert text="password_reset" type="info" />
    <BaseInput
      v-model="email"
      :disabled="isRetrieving"
      type="email"
      label="email"
      size="lg"
      :focused="focus === 'email'"
      required
    />
    <div class="flex justify-end">
      <BaseLink name="Login">
        <span>{{ signinText }}</span>
        <BaseIcon icon="arrow-right" class="mt-1" />
      </BaseLink>
    </div>
    <BaseSpacer />
    <BaseButton
      type="submit"
      class="w-full"
      size="lg"
      :loading="isRetrieving"
      action="send_password_link"
    />
  </form>
</template>

<script>
import {BaseLink, BaseSpacer, BaseInput, BaseAlert, BaseIcon, BaseButton} from '@/components/base'
export default {
  components: {
    BaseLink,
    BaseSpacer,
    BaseInput,
    BaseAlert,
    BaseIcon,
    BaseButton,
  },
  data() {
    return {
      email: '',
      focus: 'email',
      isRetrieving: false,
    }
  },
  computed: {
    signinText() {
      return this.$t('mygwf.views.RequestPasswordReset.link.signin')
    },
  },
  methods: {
    async retrievePassword(credentials) {
      this.isRetrieving = true
      this.focus = ''
      try {
        await this.$store.dispatch('users/sendResetPassword', credentials)
      } catch (error) {
      } finally {
        this.$store.dispatch('app/notification', {
          type: 'info',
          group: 'auth',
          text: `reset_password`,
        })
        this.$router.push({path: '/login'})
      }
    },
  },
}
</script>
